import React, { useEffect } from "react"
import { Layout } from "antd"
import styles from "./PersonalInfoLayout.module.css"
import { Sidebar } from "./Sidebar"
import { SubHeader } from "./SubHeader"
import { useDispatch, useSelector } from "react-redux"
import { setMenuItemActive } from "store/pro-wizard-menu"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { routes } from "router"
import { guideSelector, updateGuide } from "store/user"

const { Content } = Layout

export const PersonalInfoLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { id, email, phone_number } = useSelector(guideSelector)
  const user = useSelector((store) => store.user)

  useEffect(() => {
    const menuId = location.pathname.split("/").filter(Boolean).pop()
    dispatch(setMenuItemActive(menuId))
  }, [dispatch, location.pathname])

  useEffect(() => {
    if (id) {
      const guideObj = {}
      if (!email && user.email) {
        guideObj.email = user.email
      }
      if (!phone_number && user.phone_number) {
        guideObj.phone_number = user.phone_number
      }
      if (Object.keys(guideObj).length !== 0) {
        dispatch(updateGuide(id, { guide: guideObj }))
      }
    }
  }, [dispatch, email, phone_number, user.email, user.phone_number, id])

  if (!id) {
    return <Navigate to={routes.guideRootPath()} replace />
  }

  return (
    <Layout className={styles.layout}>
      <SubHeader />
      <Layout className={styles.contentLayout}>
        <Sidebar />
        <Content className={styles.content}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
